<template>
  <div class="rwm-text-field" :style="{maxWidth: `${width}px`}">
    <div :class="['rwm-text-field__input-field', {'active' : isFocus}, {'error' : error}, {'select' : isSelectComponent}, {'disabled' : disabled}]" @click="isSelectComponent ? $emit('selectClick') : ''">
      <div class="rwm-text-field__input-field__input-container">
        <input
            v-if="!textarea"
            v-bind="$attrs"
            :value="value"
            :class="['rwm-text-field__input-field__input-container__input']"
            :type="type"
            placeholder=" "
            :readonly="readonly"
            @input="$emit('input', $event.target.value)"
            :disabled="disabled"
            @focus="focus()"
            autocomplete="new-password"
            @blur="blur($event)"
            @click="$emit('click', $event)"
        >
        <textarea
                v-else
                v-bind="$attrs"
                :value="value"
                :class="['rwm-text-field__input-field__input-container__input', 'textarea']"
                :style="{'height': height}"
                :type="type"
                placeholder=" "
                :readonly="readonly"
                @input="$emit('input', $event.target.value)"
                :disabled="disabled"
                @focus="focus()"
                autocomplete="off"
                @blur="blur($event)"
        />
        <label>{{label}}</label>
      </div>
      <div :class="['append-icon', {'select-component' : isSelectComponent}]" @click="onAppend">
        <slot name="append-icon"/>
      </div>
    </div>
    <slot name="list"/>
  </div>
</template>
<script>
export default {
  name: "RwmTextField",
  props: {
    mask: String,
    textarea: {
      type: Boolean,
      default: false
    },
    height: {
      type: [String, Number],
      default: "",
    },
    value: {
      type: [String, Number],
      default: "",
    },
    type: {
      type: String,
      default: "text"
    },
    width: {
      type: String,
      default: "100%"
    },
    label: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: undefined
    },
    error: {
      type: Boolean,
      default: undefined
    },
    append: {
      type: String,
      default: undefined
    },
    isSelectComponent: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      isFocus: false,
    }
  },
  methods: {
    focus() {
      this.isFocus=true
      this.$emit('focus')
    },
    blur(e) {
      this.isFocus=false
      this.$emit('blur', e)
    },
    onAppend() {
      if (!this.isSelectComponent) this.$emit('onAppend')
    }
  }
}
</script>

<style scoped lang="scss">
.rwm-text-field {
  position: relative;
  text-align: left;
  &__input-field {
    display: flex;
    border: 1px solid $RWM-grey;
    border-radius: 5px;
    align-items: center;
    cursor: text;
    transition: all .3s;
    color: $RWM-grey;
    &.active {
      border-color: $RWM-dark-blue;
    }
    &__input-container {
      position: relative;
      transition: all .3s;
      flex: 1 1 auto;
      cursor: inherit;
      & input{
        font-family: NotoSans,sans-serif;
        width: 100%;
        font-weight: normal;
        font-size: 19px;
        line-height: 26px;
        color: $RWM-dark;
        cursor: inherit;
        padding: 0 25px;
        &:-webkit-autofill {
          -webkit-text-fill-color: $RWM-dark-blue;
          -webkit-box-shadow: 0 0 0px 1000px $RWM-white inset;
          transition: background-color 5000s ease-in-out 0s;
        }
        &:focus {
          outline: none;
        }
      }
      &__input {
        border: none;
        box-sizing: border-box;
        position: relative;
        height: 44px;
        z-index: 1;
        background-color: transparent;
        &:after {
          content: "";
          position: absolute;
          top: 0;
          bottom: 0;
          left: 0;
          right: 0;
          background: $RWM-white;
          z-index: -1;
        }
      }
      &__input ~ label {
        position: absolute;
        left: 25px;
        top: 9px;
        z-index: 0;
        color: $RWM-grey;
        transition: all 0.2s;
        font-weight: normal;
        font-size: 19px;
        line-height: 26px;
        display: flex;
        max-width: 100%;
        overflow: hidden;
        white-space: nowrap;
        opacity: .5;
      }
      &__input:hover {
        border-color: $RWM-dark;
      }
      &__input:hover ~ label {
        color: $RWM-dark;
      }
      &__input:focus-visible {
        outline: none;
      }
      &__input:focus ~ label,
      &__input:not(:placeholder-shown) ~ label {
        top: -14px;
        left: 25px;
        font-weight: normal;
        font-size: 15px;
        line-height: 20px;
        z-index: 10;
        padding: 0 4px;
        background-color: $RWM-white;
        opacity: 1;
      }
      &__input:focus {
        border-color: $RWM-dark-blue;
      }
      &__input:focus ~ label {
        color: $RWM-dark-blue;
      }
      // if disabled
      &__input:disabled {
        color: $RWM-dark;
        & ~ label {
          z-index: 1;
        }
        &:not(:placeholder-shown) ~ label {
          color: $RWM-grey;
          background-color: $RWM-block;
          &:after {
            content: "";
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            bottom: 7px;
            z-index: -1;
            background-color: $RWM-white;
          }
        }
      }
    }
    & .append-icon {
      transition: color 300ms;

      & > svg,
      & > div,
      & .v-icon,
      & > p {
        margin: 0 10px;
        cursor: pointer;
      }
      &.select-component {
        & > svg,
        & > div,
        & .v-icon,
        & > p {
          cursor: default;
          z-index: 0;
        }
      }
    }
    &:hover {
      border-color: $RWM-dark;
    }
    // if select component
    &.select {
      cursor: default;
      transition: border-bottom-color .1s;
    }
    &.select.active {
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
      border-bottom-color: $RWM-white;
    }
    //  if error
    &.error {
      border: 1px solid $RWM-red;
      .append-icon {
        color: $RWM-red;
      }
    }
    &.error &__input-container label {
      color: $RWM-red;
    }
    &.disabled {
      background-color: $RWM-block;
    }
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s ease;
  }
  .fade-enter, .fade-leave-to {
    opacity: 0;
  }
  & .textarea {
    width: 100%;
    height: 74px;
    resize: none;
    font-family: "NotoSans", sans-serif;
    font-size: 18px;
    padding: 10px 25px;
    margin-bottom: -5px;
    color: $RWM-dark;
    cursor: auto;
    @media screen and (min-width: 1360px) {
      height: 46px;
    }
    &::-webkit-scrollbar {
      width: 7px;
    }

    &::-webkit-scrollbar-track {
      box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    }

    &::-webkit-scrollbar-thumb {
      background-color: $RWM-grey;
    }
  }
//  autofill

}
</style>
